import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

export const selectDashboard = (state: RootState) => state.dashboard;
export const selectServiceRequests = createSelector(selectDashboard, (state) => state.serviceRequests);
export const selectDashboardIsLoading = createSelector(selectDashboard, (state) => state.isLoading);
export const selectDashboardNextPage = createSelector(selectDashboard, (state) => state.nextPage);
